import { Link } from 'react-router-dom';
import { useLanguage } from '../LanguageContext';

export default function PrivacyPage() {
  const { t } = useLanguage();

  return (
    <main className="legal-page">
      <article className="legal-prose">
        <p className="legal-prose__notice">{t('privacy.notice')}</p>

        <h1>{t('privacy.title')}</h1>
        <p className="legal-prose__meta">
          <strong>Last Updated:</strong> July 2026
        </p>

        <h2>7. Donor Privacy &amp; Data Protection</h2>
        <p>
          <strong>7.1</strong> {t('privacy.s71')}
        </p>
        <p>
          <strong>7.2</strong> {t('privacy.s72')}
        </p>
        <p>
          <strong>7.3</strong> {t('privacy.s73intro')}
        </p>
        <ul>
          <li>{t('privacy.s73a')}</li>
          <li>{t('privacy.s73b')}</li>
          <li>{t('privacy.s73c')}</li>
        </ul>
        <p>
          <strong>7.4</strong> {t('privacy.s74')}
        </p>
        <p>
          <strong>7.5</strong> {t('privacy.s75')}
        </p>

        <p>
          For the full Terms &amp; Conditions, see{' '}
          <Link to="/terms">Terms &amp; Conditions</Link>.
        </p>

        <p className="legal-prose__back">
          <Link to="/">&larr; {t('legal.backToHome')}</Link>
        </p>
      </article>
    </main>
  );
}
